import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheArtOfSushiInYerevan from "./sections/TheArtOfSushiInYerevan";
import SecureYourTable from "./sections/SecureYourTable";
import RutasInexploradasDestinosEstrella from "./sections/RutasInexploradasDestinosEstrella";
import AMomentOfReflection from "./sections/AMomentOfReflection";
import GetStartedCta from "./sections/GetStartedCta";
import IslandStatus from "@/reusable_sections/Footer";
import Foundation from "./sections/Foundation";
import About from "./sections/About";
import AboutCopy from "./sections/AboutCopy";
import AboutCopy2 from "./sections/AboutCopy2";
import CoreBelief from "./sections/CoreBelief";
import ShowroomBanner from "./sections/ShowroomBanner";
import Reservationbutton from "./sections/Reservationbutton";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheArtOfSushiInYerevan />
      <ShowroomBanner />
      <CoreBelief />
      <About />
      <AboutCopy />
      <AboutCopy2 />
      <Foundation />
      <RutasInexploradasDestinosEstrella />
      <GetStartedCta />
      <AMomentOfReflection />
      <SecureYourTable />
      <Reservationbutton />
      <IslandStatus />
    </div>;
}